import * as React from "react";
import Styled from "styled-components/macro";
import Media from "@uizard-io/styled-media-query";
import Headline from "../../../texts/Headline";
import Description from "../../../texts/Description";
import Image, { GatsbyImageProps } from "gatsby-image";
import MediaQuery from "../../../layout/MediaQuery";

const Container = Styled.div`
  text-align: center;
  margin-top: 8rem;
  
   ${Media.lessThan("medium")`
    margin-top: 5rem;
  `}
`;

const Columns = Styled.div`
  display: flex; 
  justify-content: space-between;
  
   ${Media.lessThan("700px")`
    flex-direction: column;
  `}

  margin-bottom: 5rem;
`;

const HeadlineExtended = Styled(Headline)`
  margin: 10rem 0 1.5rem 0;

  ${Media.greaterThan("large")`
    margin: 15rem 0 3.5rem 0;
  `}
`;

const Column = Styled.div`
  width: calc(32%);
  ${Media.lessThan("700px")`
    width: 100%;
  `}
`;

const Stats = Styled.span`
  font-size: 3rem;
  line-height: 3.6rem;
  font-weight: 600;
  color: inherit;
  letter-spacing: -0.3px;

  ${Media.greaterThan("large")`
    font-size: 4.6rem;
    line-height: 4.8rem;
  `}
`;

const ExtendedDescription = Styled(Description)`
  font-size: 2.5rem;
  max-width: 26rem;
  margin: 0 auto 2rem auto;

  ${Media.greaterThan("large")`
    margin: 0 auto 3.5rem auto;
  `}
`;

const ImageMobile = Styled(Image)`
  width: 100%;
  border-radius: 20px;
`;

const ImageDesktop = Styled(Image)`
  width: 100%;
  border-radius: 20px;
`;

type AboutTeamProps = {
  imageA: GatsbyImageProps;
  imageB: GatsbyImageProps;
};

export default ({ imageA, imageB }: AboutTeamProps) => (
  <Container>
    <HeadlineExtended>Our community</HeadlineExtended>
    <Columns>
      <Column>
        <Stats>45</Stats>
        <ExtendedDescription>members in the Uizard team</ExtendedDescription>
      </Column>

      <Column>
        <Stats>17</Stats>
        <ExtendedDescription>
          nationalities in the Uizard team
        </ExtendedDescription>
      </Column>

      <Column>
        <Stats>10</Stats>
        <ExtendedDescription>
          countries where the Uizard team is based
        </ExtendedDescription>
      </Column>
    </Columns>

    <Columns>
      <Column>
        <Stats>10,000+</Stats>
        <ExtendedDescription>
          new projects designed in Uizard each week
        </ExtendedDescription>
      </Column>

      <Column>
        <Stats>25,000+</Stats>
        <ExtendedDescription>
          teams around the world use Uizard
        </ExtendedDescription>
      </Column>

      <Column>
        <Stats>1,000,000+</Stats>
        <ExtendedDescription>professionals use Uizard</ExtendedDescription>
      </Column>
    </Columns>

    <MediaQuery lessThan="718px">
      <ImageMobile
        fluid={"fluid" in imageB ? imageB.fluid : null}
        alt="Picture of the Uizard team enjoying social activities"
      />
    </MediaQuery>

    <MediaQuery greaterThan="718px">
      <ImageDesktop
        fluid={"fluid" in imageA ? imageA.fluid : null}
        alt="Picture of the Uizard team enjoying social activities"
      />
    </MediaQuery>
  </Container>
);
